// @ts-nocheck
import React, {ReactNode} from 'react';
import Page from '@episerver/spa-core/Page';
import KmsiPageData from '../../../Models/Content/KmsiPageData';
import Kmsi from './Kmsi';

export default class KmsiPage extends Page<KmsiPageData> {
  public render(): ReactNode {
    return (
      <div>
        <Kmsi context={this.getContext()} iContent={this.props.data} />
      </div>
    );
  }
}
